module.exports = __webpack_public_path__ + "img/lens-160-minus-09.7831b03d.png";